import "./reducer.js";
import "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
//#region src/redux/config.ts
var useCoreDispatch = () => useDispatch();
var useCoreSelector = useSelector;
//#endregion
export { useCoreDispatch, useCoreSelector };

//# sourceMappingURL=config.js.map